/**
 * @deprecated - in app router we integrate it through next/script inside ThirdPartyScripts
 * @todo - remove this component, uninstall react-livechat once migrated landing pages to app router
 */

'use client';

import React, { useEffect, useState } from 'react';
import ReactLiveChat from 'react-livechat';
import config from 'config';
import PropTypes from 'prop-types';
import { useRenderAfterHydration } from '$util/hooks/useRenderAfterHydration';

let isInitLiveChat = false;

const openChatClass = 'chat--open';
const getLiveChatAPI = () => window.LC_API;
const isApiReady = () => {
  const api = getLiveChatAPI();
  if (api && api.get_window_type()) return api;
  return false;
};

export const showLiveChat = () => {
  const chatBubble = document.getElementById('chat-widget-container');

  if (chatBubble) chatBubble.style.display = 'block';

  setTimeout(() => {
    try {
      const api = isApiReady();
      if (api) api.open_chat_window();
      isInitLiveChat = true;
    } catch (err) {
      console.error(err);
    }
  }, 500);
};

export const minimiseLiveChat = () => {
  setTimeout(() => {
    try {
      const api = isApiReady();
      if (api) api.minimize_chat_window();
      isInitLiveChat = true;
    } catch (err) {
      console.warn('err', err);
    }
  }, 500);
};

export default function LiveChat({ pageType, initChat }) {
  const liveChatId = config.get('public.livechat_id');
  const renderCSR = useRenderAfterHydration(
    // eslint-disable-next-line no-process-env
    () => !process.env.NEXT_PUBLIC_LOCAL && liveChatId && pageType !== 'widget'
  );
  const [loaded, setLoaded] = useState(isInitLiveChat);

  const onChatLoaded = (ref) => {
    if (!loaded) setLoaded(true);
    if (ref instanceof Object) {
      // eslint-disable-next-line no-param-reassign
      ref.on_chat_window_opened = () => document.body.classList.add(openChatClass);
      // eslint-disable-next-line no-param-reassign
      ref.on_chat_window_minimized = () => document.body.classList.remove(openChatClass);
    }
  };

  useEffect(() => {
    if (loaded) {
      setTimeout(() => {
        const chatBubble = document.getElementById('chat-widget-container');
        if (chatBubble) {
          chatBubble.style.display = 'block';
          if (!initChat) minimiseLiveChat();
        }
      }, 2000);
    }
  }, [initChat, loaded]);

  if (!renderCSR) return null;
  return <ReactLiveChat license={liveChatId} onChatLoaded={(ref) => onChatLoaded(ref)} />;
}

LiveChat.propTypes = {
  pageType: PropTypes.string,
  initChat: PropTypes.bool,
};

LiveChat.defaultProps = {
  pageType: '',
  initChat: false,
};
